import * as t from './actionTypes';

const initialState = {
  projectLimitData: {},
};

const internalToolsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case t.FETCH_PROJECT_LIMIT_DATA_RESPONSE: {
      return {
        ...state,
        projectLimitData: action.response,
      };
    }
    case t.FETCH_PROJECT_LIMIT_DATA_REQUEST: {
      return {
        ...state,
      };
    }
    case t.FETCH_PROJECT_LIMIT_DATA_ERROR: {
      return {
        ...state,
        projectLimitData: {},
      };
    }
    default: {
      return state;
    }
  }
};

export default internalToolsReducer;
